$(document).ready(function(){

//// For ads ons
$('#engraved_text').on('input change', function() {
    // Get the value of engraved_text
    var engravedValue = $(this).val();
    // Set the value to engrave-text
    $('#engrave-text').val(engravedValue);
});

$('#choose-your-deesign-style').on('change', function() {
    // Get the selected value
    var selectedValue = $(this).val();
    // Set the selected value to the select with id choose_your_deesign_style
    $('#choose_your_deesign_style').val(selectedValue);
});



///// To remove the add on item from cart if that is only item in the cart
  // Function to check the cart
    function checkCart() {
        $.ajax({
            url: '/cart.js',
            type: 'GET',
            dataType: 'json',
            success: function(cart) {
                var items = cart.items;
                if (items.length === 1 && items[0].variant_id === 48903871201594) {
                    removeItemFromCart(items[0].id);
                } else {
                   // console.log("something else");
                }
            },
            error: function() {
                console.error("Failed to fetch cart data.");
            }
        });
    }

    // Function to remove an item from the cart
    function removeItemFromCart(itemId) {
        $.ajax({
            url: '/cart/change.js',
            type: 'POST',
            dataType: 'json',
            data: {
                id: itemId,
                quantity: 0
            },
            success: function(cart) {
                //console.log("Item removed from cart.");
                location.reload(); // Refresh the page
            },
            error: function() {
                console.error("Failed to remove item from cart.");
            }
        });
    }

    // Observe changes in the #main-cart-items element
    var targetNode = document.getElementById('main-cart-items');
    if (targetNode) {
        var observer = new MutationObserver(function(mutationsList, observer) {
            checkCart();
        });

        var config = { childList: true, subtree: true };
        observer.observe(targetNode, config);
    }

    // Initial check on page load
    checkCart();

  
});

$(document).ready(function () {
    // Initially, show the first tab content and add 'active' to the first tab trigger
    $(".seller-tab-trigger").first().addClass("active");
    $(".sellertab-img-wrapper").hide().first().show();

    // Tab click functionality
    $(".seller-tab-trigger").click(function () {
        // Get the index of the clicked tab
        var index = $(this).index();

        // Remove active class from all triggers and add it to the clicked one
        $(".seller-tab-trigger").removeClass("active");
        $(this).addClass("active");

        // Fade out all content and fade in the selected one
        $(".sellertab-img-wrapper").stop(true, true).fadeOut(0).eq(index).fadeIn(500);
    });
});

// testimonial slider here 
$('.testi-slider').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: true,
    autoplay: true,
    autoplaySpeed: 6000,
    infinite: true,
    arrows: false,
});
$('.blogs-slider').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '200px',
    dots: false,
    // autoplay: true,
    // autoplaySpeed: 6000,
    infinite: true,
    arrows: false,
});